import React from 'react';

import { CardSection, IconCreditCard } from '@maiia/design-system';
import { Box, Stack, Typography } from '@mui/material';

import { getSector } from '../../../utils/card';
import Tag from '../../../atoms/Tag/Tag';
import { useTranslation } from '@/src/i18n';
import Tarif from '@/components/molecules/Hcd/Tarif';
import IconModalIndication from '@/components/molecules/IconModalIndication/IconModalIndication';
import PaybackIndications from '@/components/molecules/Hcd/Payback/PaybackIndications';
import { analyticsEvent } from '@/src/analytic_tag_manager';

const paymentMethods = ['CB', 'CASH', 'CHECK'];
const refundMethods = ['THIRD_PARTY_PAYER', 'VITAL_CARD'];

type Props = {
  card: any;
};

const Payback = ({ card }: Props) => {
  const { t } = useTranslation();
  const cardPaymentMethods = card?.publicInformation?.paymentMethods || [];
  const cardRefundMethods = card?.publicInformation?.refundMethods || [];
  const hasConventionSectors =
    card?.publicInformation?.conventionSectors?.length > 0;

  return (
    <CardSection
      icon={<IconCreditCard />}
      title={t('rates_and_refunds')}
      indicationIcon={
        <IconModalIndication
          title={t('payback-indications-title')}
          message={<PaybackIndications />}
          data-cy="payback-indications-icon"
          aria-label={t('accessibility-payback-indications')}
          onOpen={() => {
            analyticsEvent({
              category: 'Tooltip',
              action: 'TooltipOpenClick',
              label: 'payback-tooltip',
            });
          }}
        />
      }
    >
      <Stack spacing={2}>
        {hasConventionSectors && (
          <Box display="flex" flexWrap="wrap" alignItems="center">
            {card.publicInformation.conventionSectors.map(sector => (
              <Tag key={sector}>{t(getSector(sector))}</Tag>
            ))}
            {refundMethods.map(refundMethod => (
              <Tag
                className="secondary"
                key={refundMethod}
                ko={!cardRefundMethods.includes(refundMethod)}
              >
                {t(`refund_method_${refundMethod.toLowerCase()}`)}
              </Tag>
            ))}
          </Box>
        )}

        <Box>
          <Typography component="h3" variant="h6">
            {t('payment-methods')}
          </Typography>
          <Box display="flex" flexWrap="wrap" alignItems="center">
            {paymentMethods.map(paymentMethod => (
              <Tag
                className="primary"
                key={paymentMethod}
                ko={!cardPaymentMethods.includes(paymentMethod)}
              >
                {t(`payment_method_${paymentMethod.toLowerCase()}`)}
              </Tag>
            ))}
          </Box>
        </Box>

        <Tarif card={card} />
      </Stack>
    </CardSection>
  );
};

export default Payback;
